import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage, FormattedNumber, injectIntl } from 'react-intl';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookCalculatorAmountStore from 'book-calculator/stores/BookCalculatorAmountStore';
import { FieldSet, Field } from 'common/components/Form';
import { Button } from '@99designs/common/components/Button';
import { submit } from 'book-calculator/actions/submit';

class Summary extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);

        this.state = {
            isEmailSubmitted: false,
        };
    }

    submit(e) {
        e.preventDefault();

        if (this.emailField.value) {
            this.context.executeAction(submit, {
                email: this.emailField.value,
            });

            this.setState({ isEmailSubmitted: true });
        }
    }

    render() {
        return (
            <div>
                <div className="heading heading--h0">
                    <FormattedMessage id="steps.summary.heading" />
                </div>
                <div className="heading heading--final-tally">
                    <FormattedNumber
                        value={this.props.totalAmount}
                        style="currency"
                        currency={'USD'}
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                    />
                </div>
                <div className="paragraph paragraph--root paragraph--half-margin">
                    <FormattedMessage id="steps.summary.disclaimer" />
                </div>
                {this.state.isEmailSubmitted ? this.renderThanks() : this.renderEmailForm()}
            </div>
        );
    }

    renderEmailForm() {
        return (
            <form onSubmit={this.submit}>
                <FieldSet twoColumn={false}>
                    <Field>
                        <div className="button-group button-group--responsive">
                            <div className="button-group__item">
                                <input
                                    type="email"
                                    ref={node => (this.emailField = node)}
                                    required="required"
                                    className="input-text input--inline"
                                    placeholder={this.props.intl.formatMessage({
                                        id: 'steps.summary.email_field_placeholder',
                                    })}
                                />
                            </div>
                            <div className="button-group__item">
                                <Button
                                    type="submit"
                                    variations={['primary', 'chameleon', 'responsive']}
                                >
                                    <FormattedMessage id="steps.summary.submit" />
                                </Button>
                            </div>
                        </div>
                    </Field>
                </FieldSet>
            </form>
        );
    }

    renderThanks() {
        return (
            <div className="paragraph paragraph--root paragraph--narrow">
                <FormattedHTMLMessage
                    id="steps.summary.thank_you_note"
                    values={{
                        link_attrs: '/discover?category=book-cover-design',
                    }}
                />
            </div>
        );
    }
}

Summary.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

Summary.propTypes = {
    totalAmount: PropTypes.number.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(
    connectToStores(Summary, [BookCalculatorAmountStore], (context, prop) => {
        const amountStore = context.getStore(BookCalculatorAmountStore);

        return {
            totalAmount: amountStore.getAmounts().total,
        };
    })
);
